import * as React from "react";

const SliderIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
    className={className}
  >
    <path
      fill="currentColor"
      d="M4 6.563V2.5a.5.5 0 1 0-1 0v4.063a2 2 0 0 0 0 3.875V13.5a.5.5 0 0 0 1 0v-3.062a2 2 0 0 0 0-3.876M3.5 9.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2m5-5.937V2.5a.5.5 0 1 0-1 0v1.063a2 2 0 0 0 0 3.875V13.5a.5.5 0 0 0 1 0V7.438a2 2 0 0 0 0-3.875M8 6.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2m6.5 4A2.004 2.004 0 0 0 13 8.563V2.5a.5.5 0 0 0-1 0v6.063a2 2 0 0 0 0 3.874V13.5a.5.5 0 0 0 1 0v-1.062a2.004 2.004 0 0 0 1.5-1.938m-2 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
    ></path>
  </svg>
);

export default SliderIcon;
